<template>
    <div class="mamMasterSubscriptHaveExpired white border-radius10">
        <el-table
                :data="listData"
                v-loading="loading"
                @sort-change="sortChange"
                stripe
                :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
                :empty-text="$t('root.noData')"
        >
            <div class="table-nodata" slot="empty">
                {{$t('root.noData')}}
            </div>
            <el-table-column
                    prop="id"
                    :label="$t('client')"
                    min-width="160px"
            >
                <template slot-scope="scope">
                    <div class="userName">{{scope.row.alias}}</div>
                    <div class="login font999">{{scope.row.login}}</div>
                </template>
            </el-table-column>
            <el-table-column
                    prop="copyNumSum"
                    :label="$t('Cumulative_number_of_follow')"
                    min-width="120px"
                    sortable
            >
            </el-table-column>
            <el-table-column
                    prop="copyLotsSum"
                    :label="$t('Cumulative_follow_lot')"
                    sortable
                    min-width="120px"
            >
            </el-table-column>
            <el-table-column
                    prop="statProfit"
                    :label="$t('Subscription_revenue')"
                    sortable
                    min-width="100px"
            >
                <template slot-scope="scope">
                    <span class=""
                        :class="{
                        'theme-color': isIncludeMinus(scope.row.statProfit),
                        'theme-green': !isIncludeMinus(scope.row.statProfit),
                        }"
                    >
                        {{scope.row.statProfit}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="subDays"
                    :label="$t('Subscription_days')"
                    sortable
                    min-width="100px"
            >
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" placement="top">
                        <div slot="content">
                            {{parseTime(scope.row.beginDate,'{y}-{m}-{d}')}} - {{parseTime(scope.row.endDate,'{y}-{m}-{d}')}}
                        </div>
                        <span>{{scope.row.subDays}} {{$t('day')}}</span>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-outer" v-if="total">
          <div class="paginnation-left">
            <size-change @sizeChange="sizeChange"></size-change>
            <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
          </div>
          <vs-pagination
            class="pagination-box"
            :max="max"
            :total="pageSize"
            v-model="page"
          ></vs-pagination>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { parseTime } from '@/utils/index'
  import { isIncludeMinus} from '@/utils/common';
  import initData from '@/mixins/initData';
  export default {
    name: 'mamMasterSubscriptHaveExpired',
    mixins: [initData],
    created(){
      this.$nextTick(() => {
        this.init();
      })
    },
    computed: {
      ...mapGetters(['language','userInfo']),
    },
    methods: {
      parseTime,
      isIncludeMinus,
      phFileter(data){
        return this.$t(data)
      },
      beforeInit(){
        this.params = {
          mtId: this.$route.params.mtid,
          page: this.page - 1,
          size: this.size,
        }
        if(this.sort){
          this.params.sort = this.sort;
        }
        this.url = '/crm/reception/querySubscriptionHistory';

        return true;
      },
    },
  };
</script>
<style lang="scss">
.mamMasterSubscriptHaveExpired {

}

</style>
